import { Flex } from 'antd';
import { Skeleton } from '../../Skeleton';
import { spacing } from '../../../theme-v2';
import { radius } from '../../../theme/radius';

export interface DocumentSkeletonProps {
  /** Optional class for layout overrides. */
  className?: string;
}

export const DocumentSkeleton = ({ className }: DocumentSkeletonProps) => (
  <Flex
    vertical
    gap={spacing.md}
    className={className}
    aria-hidden
    data-testid="document-skeleton"
    style={{ width: '100%', height: '100%', minHeight: 240 }}
  >
    <Skeleton variant="rectangular" width="45%" height={28} borderRadius={6} />
    <Skeleton variant="text" rows={3} />
    <Skeleton
      variant="rectangular"
      width="100%"
      height={200}
      borderRadius={radius.box}
    />
    <Skeleton variant="text" rows={4} />
    <Skeleton variant="text" rows={2} />
  </Flex>
);
